import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Base, UserTypes } from "./_models/index";
import * as $ from "jquery";
import { Subscription } from "rxjs/Subscription";
import { SessionManagerService } from "./_services/SessionManager/session-manager.service";
import { DataService } from "./_services/data.service";

export abstract class BaseComponent implements OnInit, OnDestroy {
  public loading: boolean = false;
  public UserTypesEnum = UserTypes;
  public base: Base = {};
  public subscriptions: Subscription[] = [];

  constructor(
    public dataService: DataService,
    public sessionManager: SessionManagerService
  ) {}

  abstract run();

  isUserMeshutaf() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "ADMIN" &&
      this.base.user.type &&
      this.base.user.type == this.UserTypesEnum.TYPE_MESHUTAF
    );
  }

  isUserRegular() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "USER"
    );
  }

  isUserMobile() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "ADMIN" &&
      this.base.user.type &&
      this.base.user.type >= this.UserTypesEnum.TYPE_TALPAN_WITH_MOBILE
    );
  }

  public isUserRakazKenOrUp() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "ADMIN" &&
      this.base.user.type &&
      this.base.user.type >= this.UserTypesEnum.TYPE_RAKAZ_KEN
    );
  }

  public isUserRakazMaagalOrUp() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "ADMIN" &&
      this.base.user.type &&
      this.base.user.type >= this.UserTypesEnum.TYPE_RAKAZ_MAAGAL
    );
  }

  public isUserAllowedMihlol() {
    return (
      this.base &&
      this.base.user &&
      this.base.user.role &&
      this.base.user.role == "ADMIN" &&
      this.base.user.type &&
      this.base.user.type >= this.UserTypesEnum.TYPE_RAKAZ_KEN
    );
  }

  public ngOnInit() {
    const userFromLs = JSON.parse(localStorage.getItem("currentUser"));
    this.base = {
      messages: JSON.parse(localStorage.getItem("messages")),
      user: userFromLs,
    };
    this.sessionManager.setUser(userFromLs);
    this.run();
  }

  public collapseDiv(selector) {
    $(selector).slideToggle("slow");
  }

  public addObservable(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    if (this.subscriptions && this.subscriptions.length) {
      this.subscriptions.forEach((subscription) => {
        subscription.unsubscribe();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/base.component.ts